import shotgun from './assets/shotgun.png'
import rifle from './assets/rifle.png'
import pistol from './assets/pistol.png'
import autosniper from './assets/autosniper.png'
import raygun from './assets/raygun.PNG'
import revolver from './assets/revolver.PNG'
import grenade from './assets/grenade.PNG'
import smg from './assets/smg.PNG'
import sniper from './assets/sniper.PNG'


export const pageLinks = [

    {
        id: 1,
        href: '#',
        text: 'Home'
    },
    {
        id: 2,
        href: '#about',
        text: 'About'
    },
    {
        id: 3,
        href: '#features',
        text: 'Features'
    },
]

export const dummydata = [
    { id: 1, name: 'John Doe' },
    { id: 2, name: 'Steve Wonder' }
]

export const featuresSubtitle = [{
        id: 1,
        title: 'Enemies'
    }, {
        id: 2,
        title: 'Assets'
    },
    {
        id: 3,
        title: 'Interactions'
    },
    {
        id: 4,
        title: 'Gameplay'
    },
    {
        id: 5,
        title: 'World'
    }

]



export const weapons = [{
        id: 1,
        title: 'Shot Gun',
        image: shotgun,

        desc: 'If you\'re lookingfor close - range power this weapon is your best friend.It \'s loud, it\'s messy, and it will leave the zombies with more holes than Swiss cheese.'

    },
    {
        id: 2,
        title: 'Rifle',
        image: rifle,
        category: 'Uncommon',
        desc: 'When you absolutely, positively have to kill every zombie in the room, accept no substitutes. This weapon packs a punch and will leave the undead wishing they had stayed dead.'
    },
    {
        id: 3,
        title: 'Pistol',
        image: pistol,
        category: 'Common',
        desc: 'Not the biggest gun on the block, but works as a backup to stop you from becoming zombie food when your bigger guns are out of action.'
    },
    {
        id: 4,
        title: 'Auto Sniper',
        image: autosniper,
        category: 'Rare',
        desc: 'Spray and pray like you\'re at a carnival game! This high-powered weapon mows down zombies like a lawnmower on a summer day.'
    },
    {
        id: 5,
        title: 'Ray Gun',
        image: raygun,
        category: 'Legendary',
        desc: 'Who needs bullets when you have a ray gun that shoots lasers? Blast the zombies to smithereens with this futuristic weapon, and watch them disintegrate into nothingness.'
    },
    {
        id: 6,
        title: 'Revolver',
        image: revolver,
        category: 'Rare',
        desc: 'This classic weapon never goes out of style. The six rounds in the cylinder may not seem like much, but in the hands of a skilled shooter, they can take down a whole horde.'
    },
    {
        id: 7,
        title: 'SMG',
        image: smg,
        category: 'Rare',
        desc: 'The sound of this weapon alone is enough to make the zombies run in terror. Spray and pray your way through the apocalypse with this fully automatic submachine gun.'
    },
    {
        id: 8,
        title: 'Grenade',
        image: grenade,
        category: 'Rare',
        desc: 'Throwing one of these bad boys will clear a path through the zombie horde like a hot knife through butter. Just make sure to have your earplugs ready.'
    },
    {
        id: 9,
        title: 'Sniper',
        image: sniper,
        category: 'Rare',
        desc: 'One shot, one kill. Take out the zombies from afar with this long-range weapon. It\'s perfect for picking off the undead without getting too close.'

    }

]